export const columnDef = [
    {
        headerName: "",
        field: "Id",
        cellRenderer: "Info",
        width: 60,
    },
    {
        field: "Name",
        headerName: "Product Name",
        flex: 1,
        minWidth: 200,
    },
    {
        field: "CategoryName",
        headerName: "Category",
        flex: 1,
        minWidth: 150,
    },
    {
        field: "Subcategory",
        headerName: "Subcategory",
        flex: 1,
        minWidth: 150,
    },
    {
        field: "Color",
        headerName: "Color",
        flex: 1,
        minWidth: 120,
    },
    {
        field: "UnitType",
        headerName: "Unit Type",
        flex: 1,
        minWidth: 120,
    },
    {
        field: "UnitCoverage",
        headerName: "Unit Coverage",
        flex: 1,
        minWidth: 130,
    },
    {
        field: "IsActive",
        headerName: "Status",
        flex: 1,
        minWidth: 120,
        cellRenderer: "StatusCellRenderer",
    },
];
